import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';

const sections = [
  {
    title: 'Terms',
    body: 'These pages are informational and provided for research and paper-trading practice. They do not constitute investment advice, brokerage, or tax advice.',
  },
  {
    title: 'Privacy',
    body: 'Account details, broker credentials, and activity are stored and processed to provide authenticated trading and market-data services.',
  },
  {
    title: 'Risk Disclosure',
    body: 'Paper trading simulates market activity but may not reflect real-world execution, latency, slippage, or liquidity conditions.',
  },
  {
    title: 'Data Disclaimer',
    body: 'Market data may be delayed or sourced from third-party providers. The app uses server-side normalization and may fall back between providers.',
  },
];

export default function LegalPage() {
  return (
    <PageShell title="Legal & disclosures" subtitle="Clear disclosures and provider attribution for the dashboard experience." breadcrumbs={[{ label: 'Home' }, { label: 'Legal' }]} activeTab="legal">
      <section className="dashboard-section">
        <h3>Broker & data disclosure</h3>
        <p className="muted">This application integrates with Alpaca for trading and account workflows. Market charts use a provider abstraction that prefers Polygon.io and can fall back to Yahoo Finance or Alpaca market data when needed.</p>
        <p className="muted">This service is for informational and educational purposes, and any paper-trading activity is simulated unless a live brokerage connection is explicitly enabled.</p>
      </section>
      <div className="settings-grid">
        {sections.map((section) => (
          <section key={section.title} className="dashboard-section">
            <h3>{section.title}</h3>
            <p className="muted">{section.body}</p>
          </section>
        ))}
      </div>
      <section className="dashboard-section">
        <h3>Useful links</h3>
        <div className="link-list">
          <Link to="/settings">Open settings</Link>
          <Link to="/connect-broker">Broker connection</Link>
          <a href="https://alpaca.markets" target="_blank" rel="noopener noreferrer">Alpaca</a>
          <a href="https://polygon.io" target="_blank" rel="noopener noreferrer">Polygon.io</a>
        </div>
      </section>
    </PageShell>
  );
}
